import React, { FC, useEffect } from 'react'
import styles from 'styles/components/calendar.module.scss'
import isSameMonth from 'date-fns/isSameMonth'
import { OpenStoreCalendar, OpenStoreCalendarLabel, OpenStoreArrowButton } from 'components/Calendar'
import { Spacer } from 'components/Utility'
import { StoreCalendarType } from 'types/storeCalendar'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreCurrentMonth } from 'reducks/storeCalendar/selectors'
import { fetchFutureStocks } from 'reducks/stock/operations'
import { getStoreRef } from 'reducks/auth/selectors'
import { getHolidays } from 'reducks/store/selectors'
import { endOfMonth, startOfMonth } from 'date-fns'
import { fetchClosedDates } from 'reducks/calendar/operations'
import { fetchOrdersInPeriod, initOrders, unsubscribeOrders } from 'reducks/checkout/operations'
import { getSpecialHolidays } from 'reducks/calendar/selectors'

type Props = {
  activeDate: Date | undefined
  storeCalendars: StoreCalendarType[]
  selectDate: (date: Date | undefined) => void
}

const OpenStoreCalendarContainer: FC<Props> = (props) => {
  const { activeDate, selectDate, storeCalendars } = props

  const dispatch = useDispatch()
  const currentMonth = useSelector((state: State) => getStoreCurrentMonth(state))
  const specialHolidays = useSelector((state: State) => getSpecialHolidays(state))
  const holidays = useSelector((state: State) => getHolidays(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))

  // 当日以降の在庫を取得
  useEffect(() => {
    if (!storeRef) return
    dispatch(fetchFutureStocks({ storeRef, types: ['preorder'] }))
  }, [storeRef])

  // 表示月が変わったら注文を取得する
  useEffect(() => {
    if (!currentMonth || !storeRef) return
    dispatch(initOrders())
    dispatch(
      fetchOrdersInPeriod(
        startOfMonth(currentMonth),
        endOfMonth(currentMonth),
        'deliver',
        storeRef,
        ['succeeded', 'requires_capture'],
        ['daily', 'preorder']
      )
    )
    return () => {
      dispatch(unsubscribeOrders())
    }
  }, [currentMonth, storeRef])

  // 休業日を取得
  useEffect(() => {
    if (!currentMonth || !storeRef) return
    dispatch(
      fetchClosedDates(startOfMonth(currentMonth), endOfMonth(currentMonth), holidays, specialHolidays, storeRef)
    )
  }, [currentMonth, storeRef, holidays, specialHolidays])

  return (
    <div>
      <div className={styles.calendar__monthly__header}>
        {!isSameMonth(currentMonth, new Date()) && <OpenStoreArrowButton label={'前月'} type={'prev'} />}
        <OpenStoreCalendarLabel currentMonth={currentMonth} />
        <OpenStoreArrowButton label={'翌月'} type={'next'} />
      </div>
      <Spacer size={16} />
      <OpenStoreCalendar activeDate={activeDate} storeCalendars={storeCalendars} selectDate={selectDate} />
    </div>
  )
}

export default OpenStoreCalendarContainer
